import { type FunctionComponent } from "react";
import TextField from "@/react/core/TextField.tsx";
import { deleteCurrentSetting, deliverySetting0, } from "@/react/SetShippingFeesView/SetShippingFeesLogic.tsx";
import _ from "lodash";
import { LL0 } from "@/react/core/I18nService";

export type RadiusFormType = {
  className?: string;
};

const EditRadiusForm: FunctionComponent<RadiusFormType> = ({ className = "" }) => {
  return (
    <div
      className={`self-stretch flex-1 rounded-[6px] overflow-y-auto shrink-0 flex flex-col items-start justify-start p-[10px] gap-[16px] text-left text-[14px] text-[#212121] font-[Mulish] md:gap-[14px] sm:gap-[12px] mq768:gap-[10px] mq600:gap-[8px] ${className}`}
    >
      <div className="self-stretch flex flex-col items-start justify-center gap-[4px] md:gap-[4px] sm:gap-[4px]">
        <div className="self-stretch flex flex-row items-start justify-start gap-[2px]">
          <div
            className="relative font-semibold md:text-[12px] md:w-auto md:[align-self:unset]">{LL0().deliveryManagement.deliveryRadius()}:
          </div>
          <div className="flex-1 relative font-semibold text-[#fe081b] md:text-[12px] md:w-[43px]">
            *
          </div>
        </div>
        <TextField
          type={'number'}
          value={deliverySetting0()?.distance || 0}
          onChange={(e) => {
            _.assign(deliverySetting0(), { distance: Number(e.target.value) })
          }}
          className="[border:none] bg-[transparent] self-stretch font-[Mulish] text-[14px] text-[#424242] md:pt-[9px] md:pb-[9px] md:box-border"
          color="primary"
          size="small"
          fullWidth={true}
          variant="outlined"
          sx={{ "& .MuiInputBase-root": { height: "37px" } }}
        />
      </div>
      <div className="self-stretch flex flex-col items-start justify-center gap-[4px] md:gap-[4px] sm:gap-[4px]">
        <div className="self-stretch flex flex-row items-start justify-start gap-[2px]">
          <div
            className="relative font-semibold md:text-[12px] md:w-auto md:[align-self:unset]">{LL0().deliveryManagement.deliveryFee()}:
          </div>
        </div>
        <TextField
          type={'number'}
          value={deliverySetting0()?.cost || 0}
          onChange={(e) => {
            _.assign(deliverySetting0(), { cost: Number(e.target.value) })
          }}
          className="[border:none] bg-[transparent] self-stretch font-[Mulish] text-[14px] text-[#424242] md:pt-[9px] md:pb-[9px] md:box-border"
          color="primary"
          size="small"
          fullWidth={true}
          variant="outlined"
          sx={{ "& .MuiInputBase-root": { height: "37px" } }}
        />
      </div>
      <div className="self-stretch flex flex-col items-start justify-center gap-[4px] md:gap-[4px] sm:gap-[4px]">
        <div className="self-stretch flex flex-row items-start justify-start gap-[2px]">
          <div
            className="relative font-semibold md:text-[12px] md:w-auto md:[align-self:unset]">{LL0().deliveryManagement.theMinimumOrderValue()}:
          </div>
        </div>
        <TextField
          type={'number'}
          value={deliverySetting0()?.minOrderValue || 0}
          onChange={(e) => {
            _.assign(deliverySetting0(), { minOrderValue: Number(e.target.value) })
          }}
          className="[border:none] bg-[transparent] self-stretch font-[Mulish] text-[14px] text-[#424242] md:pt-[9px] md:pb-[9px] md:box-border"
          color="primary"
          size="small"
          fullWidth={true}
          variant="outlined"
          sx={{ "& .MuiInputBase-root": { height: "37px" } }}
        />
      </div>
      <div className="self-stretch flex flex-col items-start justify-center gap-[4px] md:gap-[4px] sm:gap-[4px]">
        <div className="self-stretch flex flex-row items-start justify-start gap-[2px]">
          <div
            className="relative font-semibold md:text-[12px] md:w-auto md:[align-self:unset]">{LL0().deliveryManagement.thisDeliveryIsFreeForOrdersWorth()}:
          </div>
        </div>
        <TextField
          type={'number'}
          value={deliverySetting0()?.freeFrom || 0}
          onChange={(e) => {
            _.assign(deliverySetting0(), { freeFrom: Number(e.target.value) })
          }}
          className="[border:none] bg-[transparent] self-stretch font-[Mulish] text-[14px] text-[#424242] md:pt-[9px] md:pb-[9px] md:box-border"
          color="primary"
          size="small"
          fullWidth={true}
          variant="outlined"
          sx={{ "& .MuiInputBase-root": { height: "37px" } }}
        />
      </div>
      <div
        onClick={async () => {
          await deleteCurrentSetting()
        }}
        className="self-stretch rounded-[2px] bg-[#f4dcdc] border-[#ff5252] border-[1px] border-solid overflow-hidden shrink-0 flex flex-row items-center justify-center p-[8px] text-center text-[#000]">
        <div className="relative font-semibold sm:text-[12px] mq768:text-[13px] mq600:text-[12px] h.414:text-[12px]">
          {LL0().ui.delete()}
        </div>
      </div>
    </div>
  );
};

export default EditRadiusForm;
